import { ReactElement } from 'react';
import { renderToStaticMarkup } from 'react-dom/server';

export const svgToCssUrl = (svg: ReactElement) =>
  `url("data:image/svg+xml,${encodeURIComponent(renderToStaticMarkup(svg))}")`;
